import { cn } from "@/lib/utils";

export function WizardStepHeading({
  lead,
  rest,
  className,
}: {
  lead: string;
  rest: string;
  className?: string;
}): JSX.Element {
  return (
    <h1
      className={cn(
        "text-balance text-2xl font-semibold tracking-tight text-foreground sm:text-3xl md:text-4xl",
        className,
      )}
    >
      <span className="text-foreground">{lead}</span>{" "}
      <span className="font-normal text-muted-foreground">{rest}</span>
    </h1>
  );
}
